import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDeleteEthicsTeamGroupDetails } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface DeleteEthicsTeamGroupDetailsState {
  deleteEthicsTeamGroupDetails: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: DeleteEthicsTeamGroupDetailsState = {
  deleteEthicsTeamGroupDetails: [],
  status: "idle",
};

export const GetDeleteEthicsTeamGroupDetails = createAsyncThunk(
  "DeleteEthicsTeamGroupDetails",
  async (data: any) => {
    const response = await fetchDeleteEthicsTeamGroupDetails(data);
    return response;
  }
);

export const DeleteEthicsTeamGroupDetailsSlice = createSlice({
  name: "DeleteEthicsTeamGroupDetails",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDeleteEthicsTeamGroupDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDeleteEthicsTeamGroupDetails.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetDeleteEthicsTeamGroupDetails.fulfilled, (state, action) => {
        state.status = "success";
        state.deleteEthicsTeamGroupDetails = action.payload;
        //swal("Record saved success!",  "success");
      });
  },
});

export const {} = DeleteEthicsTeamGroupDetailsSlice.actions;

export const selectDeleteEthicsTeamGroupDetails = (state: RootState) => {
  return state.DeleteEthicsTeamGroupDetails.deleteEthicsTeamGroupDetails;
};

export default DeleteEthicsTeamGroupDetailsSlice.reducer;
